import React from "react";
import { useSelector } from "react-redux";

import Button from "@cayuse/shared-react.components.button";

import { useDictionary } from "hooks";
import { formSelectors } from "store/selectors";

import { ACTIONS } from "./constants";
import styles from "./styles.css";

const FormActions = ({ editMode, disabled, dirty, saving, actionBtnClicked, onAction }) => {
	const dictionary = useDictionary("common.form.actions");

	const { isEditLocked } = useSelector(formSelectors.entity);

	return (
		<div className={styles.actions}>
			{!editMode && (
				<Button
					secondary
					medium
					onClick={() => onAction(ACTIONS.EDIT)}
					disabled={disabled || actionBtnClicked || isEditLocked}
					tooltip={isEditLocked ? dictionary.otherUserEditing : null}
				>
					{dictionary.editBtn ?? "Edit"}
				</Button>
			)}
			{editMode && (
				<Button
					secondary
					medium
					onClick={() => onAction(ACTIONS.CANCEL)}
					disabled={disabled || actionBtnClicked}
				>
					{dictionary.cancelBtn ?? "Cancel"}
				</Button>
			)}
			<Button
				primary
				medium
				busy={saving}
				onClick={() => onAction(ACTIONS.SAVE)}
				disabled={disabled || !editMode || (editMode && !dirty)}
			>
				{dictionary.saveBtn ?? "Save"}
			</Button>
		</div>
	);
};

export default FormActions;
